// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { createHandlerChainRunner, Handler } from "@insite/client-framework/HandlerCreator";
import { xSeoStateType } from "@synd/App/Store/Reducers";

type UpdateOperation = "add" | "replace" | "delete";

export type xSeoHandlerType = {
    key: keyof xSeoStateType;
    value: any[];
    operation?: UpdateOperation;
};

export const DispatchUpdateXSeo: Handler<xSeoHandlerType> = props => {
    props.dispatch({
        type: "xSeo/update",
        data: props.parameter,
    } as any);
};

const xSeoUpdate = createHandlerChainRunner([DispatchUpdateXSeo], "xSeoUpdate");
export { xSeoUpdate };
